"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrefixedId = void 0;
var _react = require("react");
// We use generics to ensure the return type is inferred correctly

/**
 * Returns a prefixed id or array of prefixed ids from React.useId
 * that are SSR safe and unique across the application.
 * @param IdentifierPrefix - A string or array of strings to prefix the id with (optional).
 * @link https://react.dev/reference/react/useId#useid
 * @returns string | string[]
 */
const usePrefixedId = identifierPrefix => {
  const id = (0, _react.useId)();

  // If no prefix is provided, return a random id
  if (!identifierPrefix) return id;

  // If the prefix is a string, return a single prefixed id
  if (typeof identifierPrefix === 'string') {
    return `${identifierPrefix}-${id}`;
  }

  // If the prefix is an array of strings, return an array of prefixed ids
  return identifierPrefix.map(prefix => `${prefix}-${id}`);
};
exports.usePrefixedId = usePrefixedId;